import React from "react";
import Button from "./button";
import PopUp, { closePopUp } from "./popUp";

interface acceptPiecePopUpProps {
    onSend: () => void;
}

export default function AcceptPiecePopUp(props: acceptPiecePopUpProps) {
    return <PopUp title="Accept Piece">
        <p>Are you sure you want to accept this piece?</p>
        <Button onClick={() => {
            props.onSend();
            closePopUp();
        }}>Accept</Button>
    </PopUp>
}